import type { Handler } from './handler';
import type {
  ApiFetchCrashPreGameParams,
  ApiFetchCrashPreGamePort,
} from './ports/api-fetch-crash-pre-game.port';
import type { CrashPreGame } from '~/types/crash-pre-game';
import { resolveAdapter } from '~/adapters/registry';

export const fetchCrashPreGameHandler: Handler<Params, Ports, Result> = async (
  params,
  ports = {
    apiFetchCrashPreGame: resolveAdapter('apiFetchCrashPreGame'),
  },
) => {
  return await ports.apiFetchCrashPreGame.handle(params);
};

type Params = ApiFetchCrashPreGameParams;

type Ports = { apiFetchCrashPreGame: ApiFetchCrashPreGamePort };

type Result = Promise<CrashPreGame>;
